import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiMail, FiPhone } from 'react-icons/fi';

const Contact = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';
    script.async = true;
    script.onload = () => {
      if (window.jotformEmbedHandler) {
        window.jotformEmbedHandler("iframe[id='JotFormIFrame-260275044676056']", "https://form.jotform.com/");
      }
    };
    document.body.appendChild(script);
    
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section id="contact" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-brand-black rounded-[3rem] overflow-hidden shadow-3d grid lg:grid-cols-2">
          <div className="p-16 lg:p-24 text-white">
            <h2 className="text-5xl lg:text-6xl font-black mb-8">Let's Start a <br /><span className="text-brand-purple">Conversation.</span></h2>
            <p className="text-xl text-gray-400 mb-12 font-medium leading-relaxed">
              Whether you’re exploring coaching for yourself or development for your team, I’d love to connect. No pressure. No hard sell. Just a real conversation.
            </p>
            
            <div className="space-y-8">
              <div className="flex items-center space-x-6">
                <div className="w-14 h-14 bg-brand-purple rounded-2xl flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiMail} className="text-white w-6 h-6" />
                </div>
                <span className="text-xl font-bold">beckyrentzel@rgleadership.com</span>
              </div>
              
              <div className="flex items-center space-x-6">
                <div className="w-14 h-14 bg-zinc-800 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiPhone} className="text-white w-6 h-6" />
                </div>
                <span className="text-xl font-bold">+1 (614) 530-7788</span>
              </div>
            </div>
          </div>

          <div className="bg-white/5 backdrop-blur-xl p-4 lg:p-8 border-l border-white/10 flex items-center justify-center">
            <iframe
              id="JotFormIFrame-260275044676056"
              title="Form"
              onLoad={() => window.parent.scrollTo(0,0)}
              allowTransparency="true"
              allow="geolocation; microphone; camera; fullscreen; payment"
              src="https://form.jotform.com/260275044676056"
              frameBorder="0"
              style={{ minWidth: '100%', maxWidth: '100%', height: '539px', border: 'none' }}
              scrolling="no"
            >
            </iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;